export default "__VITE_ASSET__3JSeIUd8__"